// extracted by mini-css-extract-plugin
export default {"valuePropositionSection":"ValuePropositionSection_valuePropositionSection__oidSy"};